import React, { useState, useEffect } from 'react';
import {
    Container, Row, Col, Card, CardBody, FormGroup, Label, Input,
    Button, InputGroup, InputGroupText, Spinner, Alert,
    Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { hasUnpaidCancelFee } from "utils/cancelPolicy";

// --- YARDIMCI FONKSİYONLAR ---

const formatCurrencyDisplay = (value) => {
    if (!value && value !== 0) return "";
    let cleaned = value.toString().replace(/\./g, ',').replace(/[^0-9,]/g, '');
    const parts = cleaned.split(',');
    let integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    let decimalPart = parts.length > 1 ? ',' + parts[1].substring(0, 2) : '';
    return integerPart + decimalPart;
};

const parseCurrencyValue = (formattedValue) => {
    if (!formattedValue) return 0;
    return parseFloat(formattedValue.toString().replace(/\./g, '').replace(',', '.')) || 0;
};

const formatToDuration = (timeStr) => {
    if (!timeStr) return "PT00H00M0S";
    const [h, m] = timeStr.split(':');
    return `PT${parseInt(h)}H${parseInt(m)}M0S`;
};

const durationToTime = (durationStr) => {
    if (!durationStr) return "";
    const match = durationStr.match(/PT(\d+)H(?:(\d+)M)?/);
    if (!match) return "";
    const h = String(match[1] || 0).padStart(2, '0');
    const m = String(match[2] || 0).padStart(2, '0');
    return `${h}:${m}`;
};

// SÜRE HESAPLAMA VE KONTROL FONKSİYONLARI (YENİ EKLENDİ)
const parseEstimatedString = (str) => {
    if (!str || !str.includes(':')) return { hours: 0, minutes: 0, totalMs: 0 };
    const [h, m] = str.split(':').map(Number);
    const ms = ((h || 0) * 60 * 60 * 1000) + ((m || 0) * 60 * 1000);
    return { hours: h || 0, minutes: m || 0, totalMs: ms };
};

const getUserDurationInfo = (sd, st, ed, et) => {
    if (!sd || !st || !ed || !et) return null;
    const start = new Date(`${sd}T${st}`);
    const end = new Date(`${ed}T${et}`);
    const diffMs = end - start;
    if (diffMs <= 0) return { hours: 0, minutes: 0, totalMs: diffMs, isValid: false };
    
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    return { hours, minutes, totalMs: diffMs, isValid: true };
};

// --- ANA BİLEŞEN ---

const ExpenseEntry = () => {
    document.title = "Teklif Ver | LojGo";
    const { id } = useParams();
    const navigate = useNavigate();

    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
    const userId = authUser?.ID;

    const [loading, setLoading] = useState(false);
    const [hasDebt, setHasDebt] = useState(false);
    const [debtAmount, setDebtAmount] = useState(0);
    const [debtChecking, setDebtChecking] = useState(true);
    const [durationConfirmModal, setDurationConfirmModal] = useState({ open: false, estHours: 0, userHours: 0, userMinutes: 0 });

    const [offerId, setOfferId] = useState(null);
    const [expenseId, setExpenseId] = useState(null);

    const [advertDates, setAdvertDates] = useState({ start: null, end: null });
    const [estimatedDuration, setEstimatedDuration] = useState(""); // YENİ: İlanın tahmini süresini tutar

    const [offerPrice, setOfferPrice] = useState("");
    const [fuel, setFuel] = useState("");
    const [toll, setToll] = useState("");
    const [transport, setTransport] = useState("");
    const [taxi, setTaxi] = useState("");
    const [exceptional, setExceptional] = useState("");

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");

    const totalExpensesNumber = parseCurrencyValue(fuel) + parseCurrencyValue(toll) + parseCurrencyValue(transport) + parseCurrencyValue(taxi) + parseCurrencyValue(exceptional);
    const mainOfferNumber = parseCurrencyValue(offerPrice);
    const grandTotal = totalExpensesNumber + mainOfferNumber;

    const totalExpensesDisplay = formatCurrencyDisplay(totalExpensesNumber.toFixed(2).replace('.', ','));
    const grandTotalDisplay = formatCurrencyDisplay(grandTotal.toFixed(2).replace('.', ','));

    // SÜRE HESAPLAMALARINI ANLIK YAP
    const estDurInfo = parseEstimatedString(estimatedDuration);
    const userDurInfo = getUserDurationInfo(startDate, startTime, endDate, endTime);

    useEffect(() => {
        const loadInitialData = async () => {
            if (!userId || !id) return;
            // Borç kontrolü
            try {
                const { hasDebt: hd, totalDebt } = await hasUnpaidCancelFee(userId);
                setHasDebt(hd);
                setDebtAmount(totalDebt);
            } catch { /* devam et */ }
            setDebtChecking(false);
            try {
                const [advertRes, offerRes] = await Promise.all([
                    fetch(`https://hiflowapi.stechomeyazilim.info/Advert?$filter=ID eq ${id}`),
                    fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Offers?$filter=Advert_ID eq ${id} and Users_ID eq ${userId}`)
                ]);

                const advertResult = await advertRes.json();
                const offerResult = await offerRes.json();

                if (advertResult.value?.[0]) {
                    setAdvertDates({
                        start: advertResult.value[0].Advert_DateTime,
                        end: advertResult.value[0].Advert_DateTime2
                    });
                    // YENİ: Tahmini süreyi API'den state'e aktarıyoruz
                    setEstimatedDuration(advertResult.value[0].Estimated_Duration || ""); 
                }

                if (offerResult.value && offerResult.value.length > 0) {
                    const existingOffer = offerResult.value[0];
                    setOfferId(existingOffer.ID);
                    setOfferPrice(existingOffer.Price ? formatCurrencyDisplay(existingOffer.Price.toString().replace('.', ',')) : "");
                    
                    if (existingOffer.Delivery_Date) setStartDate(existingOffer.Delivery_Date.substring(0, 10));
                    if (existingOffer.DateTime_) setEndDate(existingOffer.DateTime_.substring(0, 10));
                    if (existingOffer.Start_Time) setStartTime(durationToTime(existingOffer.Start_Time));
                    if (existingOffer.End_Time) setEndTime(durationToTime(existingOffer.End_Time));

                    const expenseRes = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Expenses?$filter=Advert_Offers_ID eq ${existingOffer.ID}`);
                    const expenseResult = await expenseRes.json();

                    if (expenseResult.value && expenseResult.value.length > 0) {
                        const existingData = expenseResult.value[0];
                        setExpenseId(existingData.ID); 
                        setFuel(existingData.Fuel_Expense ? formatCurrencyDisplay(existingData.Fuel_Expense.toString().replace('.', ',')) : "");
                        setToll(existingData.Toll_Fee ? formatCurrencyDisplay(existingData.Toll_Fee.toString().replace('.', ',')) : "");
                        setTransport(existingData.Public_Transport ? formatCurrencyDisplay(existingData.Public_Transport.toString().replace('.', ',')) : "");
                        setTaxi(existingData.Taxi_Expense ? formatCurrencyDisplay(existingData.Taxi_Expense.toString().replace('.', ',')) : "");
                        setExceptional(existingData.Exceptional_Expense ? formatCurrencyDisplay(existingData.Exceptional_Expense.toString().replace('.', ',')) : "");
                    }
                }
            } catch (error) {
                console.error("Veri yükleme hatası:", error);
            }
        };
        loadInitialData();
    }, [id, userId]);

    const handleSubmitOffer = async () => {
        if (hasDebt) {
            toast.error(`${debtAmount} TL ödenmemiş cezanız var. Borcu ödemeden teklif veremezsiniz.`);
            return;
        }
        if (!startDate || !endDate || !startTime || !endTime) {
            toast.error("Lütfen başlangıç ve bitiş tarih/saat bilgilerini eksiksiz doldurun.");
            return;
        }
        if (mainOfferNumber <= 0) {
            toast.error("Lütfen geçerli bir hizmet bedeli (teklif tutarı) giriniz.");
            return;
        }
        if (userDurInfo && !userDurInfo.isValid) {
            toast.error("Başlangıç zamanı, bitiş zamanından önce olmalıdır.");
            return;
        }
        // Süre çok kısaysa önce modal ile onay al
        if (estDurInfo.totalMs > 0 && userDurInfo?.isValid && userDurInfo.totalMs < estDurInfo.totalMs * 0.7) {
            setDurationConfirmModal({ open: true, estHours: estDurInfo.hours, userHours: userDurInfo.hours, userMinutes: userDurInfo.minutes });
            return;
        }
        await doSubmit();
    };

    const doSubmit = async () => {
        setDurationConfirmModal(m => ({ ...m, open: false }));
        setLoading(true);
        try {
            const offerPayload = {
                Advert_ID: Number(id),
                Users_ID: Number(userId),
                Price: mainOfferNumber,
                Travel_Expenses: totalExpensesNumber,
                Delivery_Date: startDate,
                DateTime_: endDate,
                Start_Time: formatToDuration(startTime),
                End_Time: formatToDuration(endTime),
                Own_Offer: grandTotal,
                Created_DateTime: new Date().toISOString(),
                IsUpdated: !!offerId,
                Quickly: false,
                Offer_Status: "Bekliyor"
            };

            const offerMethod = offerId ? "PATCH" : "POST";
            const offerUrl = offerId 
                ? `https://hiflowapi.stechomeyazilim.info/Advert_Offers(${offerId})` 
                : "https://hiflowapi.stechomeyazilim.info/Advert_Offers";

            const offerResponse = await fetch(offerUrl, {
                method: offerMethod,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(offerPayload)
            });

            if (!offerResponse.ok) throw new Error("Teklif kaydedilemedi!");
            
            let currentOfferId = offerId;
            if (!offerId) {
                const newOfferData = await offerResponse.json();
                currentOfferId = newOfferData.ID;
            }

            if (totalExpensesNumber > 0 || expenseId) {
                const expensePayload = {
                    Advert_Offers_ID: Number(currentOfferId),
                    Users_ID: Number(userId),
                    Fuel_Expense: parseCurrencyValue(fuel),
                    Toll_Fee: parseCurrencyValue(toll),
                    Public_Transport: parseCurrencyValue(transport),
                    Taxi_Expense: parseCurrencyValue(taxi),
                    Exceptional_Expense: parseCurrencyValue(exceptional),
                    Total_Expense: totalExpensesNumber,
                    Created_DateTime: new Date().toISOString()
                };

                const expenseMethod = expenseId ? "PATCH" : "POST";
                const expenseUrl = expenseId 
                    ? `https://hiflowapi.stechomeyazilim.info/Advert_Expenses(${expenseId})` 
                    : "https://hiflowapi.stechomeyazilim.info/Advert_Expenses";

                const expenseResponse = await fetch(expenseUrl, {
                    method: expenseMethod,
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(expensePayload)
                });

                if (!expenseResponse.ok) throw new Error("Masraflar kaydedilemedi!");
            }

            toast.success("Teklifiniz başarıyla gönderildi!");
            setTimeout(() => navigate(`/job-details/${id}`), 1200);

        } catch (error) {
            console.error("Hata:", error);
            toast.error("Kaydedilirken bir hata oluştu: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-content">
            <ToastContainer position="top-right" autoClose={3500} />
            <Container fluid>
                <div className="d-flex align-items-center mb-4">
                    <Link to={`/job-details/${id}`} className="text-dark me-3">
                        <i className="mdi mdi-arrow-left fs-3"></i>
                    </Link>
                    <h3 className="mb-0">Teklif Oluştur n°{id}</h3>
                </div>

                {/* Borç engeli */}
                {debtChecking ? (
                    <div className="text-center py-3"><Spinner color="primary" /></div>
                ) : hasDebt && (
                    <Alert color="danger" className="d-flex align-items-center justify-content-between mb-4 shadow-sm">
                        <div>
                            <i className="mdi mdi-alert-circle-outline me-2 fs-5"></i>
                            <strong>{debtAmount} TL</strong> tutarında ödenmemiş iptal cezanız bulunmaktadır.
                            Borcu ödemeden teklif oluşturamazsınız.
                        </div>
                        <Link to="/borc-yonetimi" className="btn btn-danger btn-sm ms-3 fw-bold text-nowrap">
                            <i className="mdi mdi-credit-card-outline me-1"></i> Ceza Öde
                        </Link>
                    </Alert>
                )}

                <Row className="justify-content-center">
                    <Col lg={8}>

                        {/* ZAMAN PLANLAMASI */}
                        <Card className="mb-4 border shadow-sm">
                            <CardBody>
                                <h5 className="card-title mb-4 text-primary">
                                    <i className="mdi mdi-calendar-clock me-2"></i>1. Görev Zaman Planlaması
                                </h5>

                                {advertDates.start && advertDates.end && (
                                    <div className="alert alert-info px-3 py-2 mb-4 d-flex align-items-center" style={{fontSize: "13px"}}>
                                        <i className="mdi mdi-information fs-4 me-2"></i>
                                        <div>
                                            <strong>İlan Sahibinin Talep Ettiği Zaman Aralığı:</strong><br/>
                                            {new Date(advertDates.start).toLocaleString('tr-TR')} — {new Date(advertDates.end).toLocaleString('tr-TR')}
                                        </div>
                                    </div>
                                )}

                                {/* YENİ: SÜRE KARŞILAŞTIRMA VE BİLGİLENDİRME ALANI */}
                                {estimatedDuration && (
                                    <div className="mb-4 bg-light border rounded p-3">
                                        <div className="d-flex align-items-center mb-2">
                                            <i className="mdi mdi-map-clock text-secondary fs-5 me-2"></i>
                                            <span className="text-secondary fw-medium" style={{fontSize: "13px"}}>Sistemin Tahmini Süresi:</span>
                                            <strong className="ms-auto">{estDurInfo.hours} saat {estDurInfo.minutes > 0 ? `${estDurInfo.minutes} dk` : ""}</strong>
                                        </div>
                                        
                                        {userDurInfo && userDurInfo.isValid && (
                                            <div className="d-flex align-items-center border-top pt-2 mt-1">
                                                <i className={`mdi ${userDurInfo.totalMs < (estDurInfo.totalMs * 0.7) ? "mdi-alert text-warning" : "mdi-check-circle text-success"} fs-5 me-2`}></i>
                                                <span className={`${userDurInfo.totalMs < (estDurInfo.totalMs * 0.7) ? "text-warning" : "text-success"} fw-bold`} style={{fontSize: "13px"}}>
                                                    Sizin Planladığınız Süre:
                                                </span>
                                                <strong className="ms-auto">{userDurInfo.hours} saat {userDurInfo.minutes} dk</strong>
                                            </div>
                                        )}

                                        {userDurInfo && !userDurInfo.isValid && (
                                            <div className="d-flex align-items-center border-top pt-2 mt-1">
                                                <i className="mdi mdi-close-circle text-danger fs-5 me-2"></i>
                                                <span className="text-danger fw-bold" style={{fontSize: "13px"}}>Hatalı Saat Seçimi!</span>
                                                <span className="ms-auto text-danger" style={{fontSize: "12px"}}>Bitiş saati, başlangıçtan önce olamaz.</span>
                                            </div>
                                        )}
                                        
                                        {/* Uyarı Mesajı */}
                                        {userDurInfo && userDurInfo.isValid && userDurInfo.totalMs < (estDurInfo.totalMs * 0.7) && (
                                            <div className="text-warning mt-2" style={{fontSize: "12px"}}>
                                                <em>* Planladığınız süre tahmini süreden oldukça kısa görünüyor. Lütfen saatlerinizi kontrol edin.</em>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label className="fw-bold">Teklifinizin Başlangıç Tarihi <span className="text-danger">*</span></Label>
                                            <Input 
                                                type="date" 
                                                value={startDate} 
                                                onChange={e => {
                                                    setStartDate(e.target.value);
                                                    if (endDate && e.target.value > endDate) setEndDate(e.target.value);
                                                }} 
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label className="fw-bold">Teklifinizin Bitiş Tarihi <span className="text-danger">*</span></Label>
                                            <Input 
                                                type="date" 
                                                value={endDate} 
                                                min={startDate} 
                                                onChange={e => setEndDate(e.target.value)} 
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label className="fw-bold">Başlangıç Saati <span className="text-danger">*</span></Label>
                                            <Input 
                                                type="time" 
                                                value={startTime} 
                                                onChange={e => setStartTime(e.target.value)} 
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label className="fw-bold">Bitiş Saati <span className="text-danger">*</span></Label>
                                            <Input 
                                                type="time" 
                                                value={endTime} 
                                                onChange={e => setEndTime(e.target.value)} 
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {/* HİZMET BEDELİ & MASRAFLAR */}
                        <Card className="shadow-sm mb-4">
                            <CardBody>
                                <h5 className="card-title mb-4 text-primary">
                                    <i className="mdi mdi-cash me-2"></i>2. Fiyatlandırma
                                </h5>
                                
                                <Alert color="warning" className="border-0 bg-warning bg-opacity-10 text-warning d-flex align-items-center">
                                    <i className="mdi mdi-alert-circle-outline fs-4 me-2"></i>
                                    Hizmet bedeliniz ve varsa tahmini görev masraflarınızı giriniz.
                                </Alert>

                                <ExpenseInput label="HİZMET BEDELİNİZ (TEKLİF TUTARI) *" icon="cash-multiple" value={offerPrice} onChange={setOfferPrice} isHighlight={true} />
                                
                                <hr className="my-4"/>
                                <h6 className="text-muted fw-bold mb-3">Ekstra Görev Masrafları (Opsiyonel)</h6>

                                <ExpenseInput label="Yakıt Masrafı" icon="gas-station" value={fuel} onChange={setFuel} />
                                <ExpenseInput label="Otoyol Ücreti" icon="road-variant" value={toll} onChange={setToll} />
                                <ExpenseInput label="Toplu Taşıma" icon="bus" value={transport} onChange={setTransport} />
                                <ExpenseInput label="Taksi Gideri" icon="taxi" value={taxi} onChange={setTaxi} />
                                <ExpenseInput label="İstisnai Masraflar" icon="alert-circle" value={exceptional} onChange={setExceptional} />

                            </CardBody>
                        </Card>

                        {/* GENEL TOPLAM ÖZETİ */}
                        <Card className="border border-success shadow-none mb-4 bg-soft-success">
                            <CardBody className="d-flex justify-content-between align-items-center py-4">
                                <div>
                                    <h5 className="mb-1 text-success"><i className="mdi mdi-check-decagram me-2"></i>GENEL TOPLAM</h5>
                                    <p className="text-success mb-0" style={{opacity: 0.8}}>Hizmet Bedeli ({mainOfferNumber > 0 ? formatCurrencyDisplay(mainOfferNumber.toFixed(2).replace('.', ',')) : "0,00"} TL) + Masraflar ({totalExpensesDisplay} TL)</p>
                                </div>
                                <h2 className="mb-0 text-success fw-bold">{grandTotalDisplay} <span className="fs-5">TL</span></h2>
                            </CardBody>
                        </Card>

                        {/* GÖNDER BUTONU */}
                        <div className="text-end mb-5">
                            <Button
                                color="success" size="lg" className="px-5 py-3 fw-bold"
                                onClick={handleSubmitOffer}
                                disabled={loading || hasDebt}
                                title={hasDebt ? "Önce cezanızı ödemeniz gerekiyor" : ""}
                            >
                                {loading ? <><Spinner size="sm" className="me-2" /> Kaydediliyor...</> : <><i className="mdi mdi-send me-2"></i> TEKLİFİ GÖNDER</>}
                            </Button>
                        </div>

                    </Col>
                </Row>
            </Container>

            {/* Süre Onay Modalı */}
            <Modal isOpen={durationConfirmModal.open} toggle={() => setDurationConfirmModal(m => ({ ...m, open: false }))} centered>
                <ModalHeader toggle={() => setDurationConfirmModal(m => ({ ...m, open: false }))} className="bg-warning text-dark">
                    <i className="mdi mdi-alert me-2"></i> Süre Uyarısı
                </ModalHeader>
                <ModalBody className="p-4 text-center">
                    <i className="mdi mdi-clock-alert-outline display-4 text-warning mb-3"></i>
                    <p className="mb-2">Sistemin tahmini süresi: <strong>{durationConfirmModal.estHours} saat</strong></p>
                    <p className="mb-3">Planladığınız süre: <strong>{durationConfirmModal.userHours} saat {durationConfirmModal.userMinutes} dk</strong></p>
                    <Alert color="warning" className="border-0 text-start font-size-13">
                        Girdiğiniz süre tahmini süreden oldukça kısa görünüyor. Saatlerinizin doğruluğuna eminseniz devam edebilirsiniz.
                    </Alert>
                </ModalBody>
                <ModalFooter className="justify-content-center border-top-0 pb-4">
                    <Button color="light" className="px-4" onClick={() => setDurationConfirmModal(m => ({ ...m, open: false }))}>
                        Geri Dön
                    </Button>
                    <Button color="warning" className="px-4 fw-bold" onClick={doSubmit}>
                        <i className="mdi mdi-check me-1"></i> Evet, Devam Et
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

// Alt komponent
const ExpenseInput = ({ label, icon, value, onChange, isHighlight }) => {
    const handleChange = (e) => {
        const formattedVal = formatCurrencyDisplay(e.target.value);
        onChange(formattedVal);
    };

    return (
        <FormGroup className="mb-3">
            <Label className={`text-uppercase fw-bold ${isHighlight ? 'text-primary fs-6' : 'text-muted'}`} style={!isHighlight ? {fontSize: "12px"} : {}}>{label}</Label>
            <InputGroup size={isHighlight ? "lg" : ""}>
                <InputGroupText className={isHighlight ? "bg-primary text-white" : "bg-light"}><i className={`mdi mdi-${icon} ${!isHighlight && 'text-primary'}`}></i></InputGroupText>
                <Input 
                    type="text" 
                    inputMode="decimal"
                    placeholder="0,00" 
                    value={value} 
                    onChange={handleChange} 
                    className={`fw-bold ${isHighlight ? 'text-primary fs-4' : 'fs-5'}`}
                />
                <InputGroupText className={`fw-bold ${isHighlight ? 'bg-primary text-white' : 'bg-light text-muted'}`}>TL</InputGroupText>
            </InputGroup>
        </FormGroup>
    );
};

export default ExpenseEntry;